import { useState } from 'react'

import Modal from 'tools/Modal'

function Popup({ children, title = '', className = 'ml2', width = 'fw-min' }) {
  const [show, setShow] = useState(false)
  return (
    <>
      <i
        className={`far br3 fa-question-circle light-silver pointer hover-lighten ${className}`}
        onClick={() => setShow(true)}
      />
      {show && (
        <Modal viewState={[show, setShow]} width={width} header={title}>
          <div className="pa4 lh-copy">{children}</div>
        </Modal>
      )}
    </>
  )
}

export default Popup
